import { render, staticRenderFns } from "./UserAccountSetting.vue?vue&type=template&id=648869ee"
import script from "./UserAccountSetting.vue?vue&type=script&lang=js"
export * from "./UserAccountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports